export default "__VITE_PUBLIC_ASSET__232dc2b5__"